import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AuthLayout from 'layouts/auth';
import { RequireAuth, useAuthUser, useIsAuthenticated } from 'react-auth-kit';
import { Toaster } from 'react-hot-toast';
import AdminLayout from 'layouts/admin/AdminLayout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Global QueryClient — lives outside the component so it persists across
// route changes and is never recreated on re-renders.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes → no refetch when navigating back
      staleTime: 5 * 60 * 1000,
      // Keep unused cache entries for 10 minutes before garbage-collecting
      gcTime: 10 * 60 * 1000,
      // Do not retry on 4xx errors (geo-restriction, auth, etc.)
      retry: (failureCount, error) => {
        if (error?.response?.status >= 400 && error?.response?.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

const App = () => {
  const isAuthenticated = useIsAuthenticated();
  // const [selectedCenter, setSelectedCentre] = useState(null);
  const [newNotif, setnewNotif] = useState(false);
  const [notification, setNotification] = useState({ title: '', body: '' });
  const auth = useAuthUser();

  useEffect(() => {
    if (notification?.title) {
      setnewNotif(true);
    }
  }, [notification]);

  // inside the jsx being returned:

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={
            <RequireAuth loginPath={'/auth/sign-in'}>
              <AdminLayout />
            </RequireAuth>
          }
        />
        <Route
          path="/"
          element={<Navigate to={!isAuthenticated() ? `/auth/sign-in` : 'admin/stats'} replace />}
        />
      </Routes>
    </QueryClientProvider>
  );
};

export default App;
